import { render, staticRenderFns } from "./StrengthPage.vue?vue&type=template&id=08454b09"
import script from "./StrengthPage.vue?vue&type=script&lang=js"
export * from "./StrengthPage.vue?vue&type=script&lang=js"
import style0 from "./StrengthPage.vue?vue&type=style&index=0&id=08454b09&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports